import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useThemeContext } from "../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../Utils/constants";
import { useTranslation } from 'react-i18next';
export const FileUpload = ({ label, onFileUpload, error, documentUrl }) => {
    const { mode } = useThemeContext();
    const [file, setFile] = useState(null);
    const { t } = useTranslation();

    const btnColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
    const textColor1 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const errorTextColor = mode === 'dark' ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];

        if (!selectedFile) return;

        if (selectedFile.type !== "application/pdf") {
            onFileUpload(null, t("franchise.onlyPDFAllowed"));
            return;
        }

        if (selectedFile.size > 5 * 1024 * 1024) {
            onFileUpload(null, t("franchise.fileSizeExceed5MB"));
            return;
        }

        setFile(selectedFile);
        onFileUpload(selectedFile, null);
    };

    return (
        <Box sx={{ textAlign: "center", border: "2px dashed #ccc", padding: "20px", borderRadius: "8px", position: "relative" }}>
            <input
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
                style={{ position: "absolute", width: "100%", height: "80%", right: 0, top: 0, bottom: 10, opacity: 0, cursor: "pointer" }}
            />
            <CloudUploadIcon sx={{ fontSize: 50, color: btnColor }} />
            <Typography sx={{ cursor: "pointer", marginBottom: "5px" }}><span style={{ color: btnColor }}>{t('franchise.ClicktoUpload')}</span> {t('franchise.draganddrop')}</Typography>
            <Typography sx={{ fontSize: "12px", color: textColor1 }}>{t('franchise.Maxfilesize')}</Typography>
            <Typography sx={{ fontSize: "12px", color: textColor1 }}>{t('franchise.supportsfileformat')}</Typography>

            {/* {file && <Typography sx={{ fontSize: "12px", color: btnColor, marginTop: "10px" }}>{file.name}</Typography>} */}
            {file ? (<Typography sx={{ fontSize: "12px", color: btnColor, marginTop: "10px" }}>{file.name}</Typography>) : (
                documentUrl && <Typography sx={{ fontSize: "12px", color: btnColor, marginTop: "10px" }}>
                    {t('franchise.DocumentUploaded')} <a href={documentUrl} target="_blank" rel="noopener noreferrer" style={{ color: btnColor }}>{t('franchise.Download')}</a>
                </Typography>
            )}
            {error && <Typography sx={{ color: errorTextColor, fontSize: "12px", marginTop: "5px" }}>{error}</Typography>}
        </Box>
    );
};
